module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","material"],"commonjs":"@angular/material","commonjs2":"@angular/material","amd":"@angular/material"}
// module id = 57
// module chunks = 0